import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumbs.css';

const Breadcrumbs = () => {
  const location = useLocation();
  
  // Get path segments and filter out empty strings and 'referencias'
  const pathnames = location.pathname
    .split('/')
    .filter(x => x && x !== 'referencias');
  
  const breadcrumbNames = {
    'ksb': 'KSB',
    'tecnal': 'TECNAL',
    'clientes': 'Nuestros Clientes',
    'sobre-nosotros': 'Sobre Nosotros',
    'eventos': 'Eventos',
    'catalogos': 'Catálogos técnicos',
    'terminos': 'Términos y Condiciones',
    // TECNAL categories
    'almacenamiento-de-granos': 'Almacenamiento de granos',
    'aceite-vegetal': 'Aceite vegetal',
    'alimentacion-animal': 'Alimento balanceado',
    'movimiento-portuario': 'Movimiento portuario',
    'etanol-de-maiz': 'Etanol de maíz',
    'referencias': 'Referencias en Argentina',
    // Referencias
    'equipos-rotativos': 'Equipos rotativos',
    'expanders': 'Expanders',
    'enfriadoras': 'Enfriadoras de masa expandida',
    // KSB categories
    'bombas': 'Bombas',
    'valvulas': 'Válvulas',
    'presurizacion': 'Sistemas de presurización',
    'monitoreo': 'Monitoreo',
    'service': 'Service',
    // KSB Bombas subpages
    'catalogo': 'Catálogo',
    'aguas-efluentes': 'Aguas y efluentes',
    'defensa-inundaciones': 'Defensa contra inundaciones',
    'centrales-termicas': 'Centrales térmicas',
    'industrias': 'Industrias',
    'sistemas-incendios': 'Sistemas contra incendios',
    'building': 'Building',
    // KSB Válvulas subpages
    'productos': 'Válvulas',
    'stock': 'Stock de válvulas',
    // Aceite vegetal equipos
    'quebrador': 'Quebrador',
    'laminador': 'Laminador',
    'expander': 'Expander',
    'columna-de-aire': 'Columna de aire',
    'molino-map': 'Molino de martillos MAP',
    'molino-mmt': 'Molino de martillos MMT',
    'acondicionador-secador-rotativo': 'Acondicionador / Secador Rotativo',
    'extractor-rotativo': 'Extractor rotativo',
    'recuperacion-finos': 'Recuperación de finos',
    'dtdc': 'DTDC',
    'molino-bellota': 'Molino de bellota',
    'destileria': 'Destilería',
    'secadora-enfriadora': 'Secadora / Enfriadora',
    'secadora-acondicionador-vertical-vsc': 'Secadora / Acondicionador Vertical - VSC',
    // Alimento balanceado equipos
    'extrusora-edr': 'Extrusora EDR',
    'extrusora-eap': 'Extrusora EAP',
    'mezclador-mdp': 'Mezclador MDP',
    'mezclador-horizontal': 'Mezclador horizontal',
    'secadora-horizontal': 'Secadora horizontal',
    'enfriador-vertical': 'Enfriador vertical',
    'acondicionador-horizontal': 'Acondicionador horizontal',
    'premezcladora': 'Premezcladora',
    'extrusora-exa': 'Extrusora EXA',
    'recubridor-continuo': 'Recubridor continuo',
    'automatizacion': 'Automatización',
    // Almacenamiento de granos equipos
    'prelimpieza': 'Prelimpieza y limpieza',
    'secadora-vertical': 'Secadora vertical',
    'transportador-cinta-cerrado': 'Transportador de cinta',
    'transportador-cadena': 'Transportador de cadena',
    'cinta-transportadora': 'Cinta transportadora',
    'transporte-rosca': 'Transporte a rosca',
    'elevador-noria': 'Elevador / Noria',
    'cadenas': 'Cadenas'
  };

  // Build the correct URL for each breadcrumb segment
  const getRouteForSegment = (segments, index) => {
    const segment = segments[index];
    
    // For all paths, build URL from segments
    return '/' + segments.slice(0, index + 1).join('/');
  };
  
  // Show spacer for home page (no breadcrumb content but maintain space)
  if (pathnames.length === 0) {
    return <div className="breadcrumbs-spacer" />;
  }
  
  return (
    <div className="breadcrumbs-container" data-testid="breadcrumbs">
      <div className="breadcrumbs">
        <Link to="/" className="breadcrumb-item breadcrumb-home">
          <Home size={14} />
          <span>Principal</span>
        </Link>
        {pathnames.map((name, index) => {
          const routeTo = getRouteForSegment(pathnames, index);
          const isLast = index === pathnames.length - 1;
          const displayName = breadcrumbNames[name] || name.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ');
          
          return (
            <React.Fragment key={name + index}>
              <ChevronRight size={14} className="breadcrumb-separator" />
              {isLast ? (
                <span className="breadcrumb-item active">{displayName}</span>
              ) : (
                <Link to={routeTo} className="breadcrumb-item">{displayName}</Link>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumbs;
